`import {User} from '../models/resources'`

actions =
  setUser: (context, user) ->
    context.commit('user', user)

  setUserFromGoogle:  (context, user) ->
    new Promise((resolve, reject) ->
      User.authGoogle(user).then((res) ->
        resolve(res.body)
      , (err) ->
        reject(err)
      )
    )

  confirmUser: (context, token) ->
    new Promise((resolve, reject) ->
      User.confirm({confirmation_token: token}).then(
          (res) ->
            resolve(res.body)
        , (res) ->
          reject(res)
        )
    )

  saveUser:  (context, user) ->
    rs = User

    new Promise((resolve, reject) ->
      if user.id
        rs.update({id: user.id}, {user: user}).then(
          (res) ->
            resolve(res.body)
        , (res) ->
          reject(res)
        )
      else
        rs.save(user: user).then(
          (res) ->
            resolve(res.body)
        , (res) ->
          reject(res.body)
        )
    )


`export default actions`



// WEBPACK FOOTER //
// ./src/store/actions/users.coffee